import { DigistoreUpsellFunction } from "../public-interfaces";
import { digistoreUpsell } from "./digistoreUpsell";

export const digibankUpsell: DigistoreUpsellFunction = function ()
{
    digistoreUpsell();
};
